<template lang="pug">
.container.grid-lg.py-2
  .no-print
    form-filter(
      @submit="onFilter",
      :auto-filter="autoFilter",
      :default-query="q",
      filter-key="doc-consulta-geral"
    )

  load-manager(:status="status")
    list-manager(:status="status", :count="list.length")
      table.table.table-striped.table-sm
        thead
          tr
            th {{ "doc.numero" | tModel }}/{{ "doc.ano" | tModel }}
            th {{ "modelo.departamento" | tModel }}
            th {{ "doc.modelo" | tModel }}
            th {{ "doc.cadastro" | tModel }}
            th {{ "doc.ciencia_em" | tModel }}
            th {{ "doc.regularizar_em" | tModel }}
            th {{ "doc.autuado_em" | tModel }}
            th {{ "doc.situacao" | tModel }}
            th.text-right {{ "doc.valor_total" | tModel }}
            th.actions-col
        tbody
          tr(v-for="doc in list")
            td {{ doc.numero }}/{{ doc.ano }}
            td {{ doc.modelo.departamento.nome }}
            td {{ doc.modelo.descricao }}
            td {{ doc.cadastro.numero }}
            td {{ doc.ciencia_em | date }}
            td {{ doc.regularizar_em | date("DD/MM/YYYY") }}
            td {{ doc.autuado_em | date }}
            td {{ doc.situacao.descricao }}
            td.text-right {{ doc.valor_total | currency("R$ ") }}
            td.actions-col
              a.btn.btn-action.btn-sm.btn-link.tooltip.tooltip-left(
                :href="doc.url",
                target="_blank",
                data-tooltip="Imprimir"
              )
                btn-icon(name="print")
      .my-2.text-right(v-if="pages > 1")
        btn-paginate(
          :page="page",
          :pages="pages",
          :count="count",
          @go-page="goPage",
          @prev-page="prevPage",
          @next-page="nextPage"
        )
</template>

<script>
import { vuexDefaultMapping } from "@/mixins/list"
import FormFilter from "./Filter"

export default {
  vuex: {
    "consulta/docs": vuexDefaultMapping,
  },

  components: { FormFilter },

  data() {
    return { q: { id_order_by: "asc" } }
  },

  methods: {
    onFilter(q = {}) {
      this.q = { ...q }
      this.setQuery({ ...q })
      this.setPage(1)
      this.fetchList()
    },
  },

  computed: {
    autoFilter() {
      return !this.list || this.list.length === 0
    },
  },

  created() {
    this.q = { ...this.q, ...this.query }
  },
}
</script>
